// Auto-generated section component extracted from Landing.jsx
import React from "react";

export default function TracksSection({ api }) {
  const { t } = api || {};
  return (
<section id="tracks" className="space-y-4">
                <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
                  {t.nav.tracks}
                </h2>

                <div className="grid gap-4 md:grid-cols-3">
                  {[
                    { title: "Wealth", body: "Savings, ownership paths, and long-term stability." },
                    { title: "Opportunity", body: "Marketplace access, promotions, and training." },
                    { title: "Wellness", body: "Support programs, community aid, and resilience." },
                  ].map((c) => (
                    <div
                      key={c.title}
                      className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-5"
                    >
                      <div className="text-emerald-300 font-semibold">
                        {c.title}
                      </div>
                      <div className="mt-2 text-sm text-slate-200">{c.body}</div>
                    </div>
                  ))}
                </div>
              </section>
  );
}
